import clsx from 'clsx';
import NextLink from 'next/link';
import styles from './Link.module.scss';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  title: string;
  ariaLabel?: string;
  children: React.ReactNode;
  className?: string;
}

export const Link: React.FC<LinkProps> = ({
  href,
  title,
  ariaLabel = title,
  children,
  className,
  ...props
}) => (
  <NextLink
    href={href}
    title={title}
    aria-label={ariaLabel}
    {...props}
    className={clsx(styles.link, className)}
  >
    {children}
  </NextLink>
);
